import * as React from "react";
import { Button } from "react-bootstrap";
import { imagePathurl } from "../../utils/utils";
import { STRUCTURE_TYPE } from "./constant";

const getimagePath = imagePathurl();
const getAddressDetails = (buildingAddress) => {
    const { addressLine1, city, stateOrProvince, zipOrPostal, country } = buildingAddress;
    return `${addressLine1}, ${city}, ${stateOrProvince}, ${zipOrPostal}, ${country}`;
};
const getOwnerInfo = (owner) => {
    return `${owner.firstName} ${owner.lastName}`;
};
const CartItems: React.FC<any> = (props) => {
    const { items, disableActions, deleteItem, editItem, reviewItem, copyItem } = props;
    return (
        <>
            {items.map((item, i) => {
                const isRefunded = item.isRefunded;
                return (
                    <div className="items-row" key={`cart items-${i}`}>
                        <div className={isRefunded ? "plain-card refunded-item" : "plain-card"}>
                            <img
                                className="plain-card-icon"
                                src={`${getimagePath}${STRUCTURE_TYPE[item.structureType].imgsrc}`}
                                alt="Single Family"
                            />
                        </div>
                        <div className="card-content">
                            <div className="item-content">
                                <div className={isRefunded ? "item-description refunded-item" : "item-description"}>
                                    <div className="item-details">
                                        <div className="item-element item-address">
                                            {getAddressDetails(item.buildingAddress)}
                                        </div>
                                        <div className="item-element item-owner">{getOwnerInfo(item.owner)}</div>
                                        <div className="item-element item-structure-type">
                                            {STRUCTURE_TYPE[item.structureType].label} {disableActions && `( ${item.warrantyNumber})`}
                                        </div>
                                    </div>
                                    <div className="item-price">${`${parseFloat(item.amount).toFixed(2)}`}</div>
                                </div>
                                <div className="item-actions">
                                    <div className={!isRefunded ? "d-none " : ""}>
                                        <Button onClick={() => {}}>Refunded</Button>
                                    </div>
                                    <div className={disableActions ? "d-none " : ""}>
                                        <Button onClick={() => editItem(item.warrantyId, item.id)}>Edit</Button>
                                    </div>
                                    <div className={disableActions ? "d-none " : ""}>
                                        <Button onClick={() => reviewItem(item.warrantyId)}>Review</Button>
                                    </div>
                                    <div className={disableActions ? "d-none " : ""}>
                                        <Button onClick={() => copyItem(item.warrantyId)}>Copy</Button>
                                    </div>
                                    <div className={disableActions ? "d-none " : ""}>
                                        <Button onClick={() => deleteItem(item.id)}>Remove</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default CartItems;
